// src/apiClient.js

import { getUser, refreshTokenIfExpired } from ".";

const API_BASE_URL = process.env.REACT_APP_API_URL; // Replace with your base URL

/**
 * Custom fetch instance to handle API requests
 * @param {string} endpoint - The API endpoint to fetch.
 * @param {object} options - Custom configurations for the fetch request (method, headers, body, etc.)
 * @returns {Promise} - Returns the fetch promise.
 */

const apiClient = async ({
  endpoint = "",
  method = "GET", // Default to GET method
  data = {},
  options = {},
  token,
  query,
}) => {
  // Set up default headers
  let defaultHeaders = data instanceof FormData ? {
  } : {
    "Content-Type": "application/json",
  };

  // Add token to headers if available
  defaultHeaders =
    token || getUser()?.accessToken
      ? {
        ...defaultHeaders,
        Authorization: `Bearer ${token ?? getUser()?.accessToken}`,
      }
      : defaultHeaders;

  // Authorization: `Bearer ${token ?? getUser()?.accessToken}`, // Example for including a token

  // Modify the config setup
  let config = {
    ...options,
    method: method,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  // Only stringify the body if it's not FormData
  config =
    method === "GET" || method === "get"
      ? config
      : {
        ...config,
        body: data instanceof FormData ? data : JSON.stringify(data),
      };

  const queryStr = (method === "GET" || method === "get") && query ? '?' + new URLSearchParams(query).toString() : '';

  // Construct the full URL
  const url = `${API_BASE_URL}/${endpoint}${queryStr}`;

  // console.log("🚀 ~ url:", url)
  try {
    // Check token, otherwise update it
    if (!token) refreshTokenIfExpired();

    const response = await fetch(url, config);

    // Check if the response status is OK (between 200 and 299)
    if (!response.ok) {
      // Optionally handle unauthorized responses or other specific error codes here
      if (response.status === 401) {
        console.error("Unauthorized access - Token may be invalid or expired");
      }
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    // Parse and return JSON response if successful
    return await response.json();
  } catch (error) {
    console.error("API request failed:", error);
    throw error; // Re-throw error to handle it in the calling function
  }
};

export default apiClient;
